import { createReducer } from "@reduxjs/toolkit";
import * as actionTypes from "~/store/action_types";

const reducer = createReducer({}, (builder) => {
  builder.addCase(actionTypes.FETCH_ACTIVITY_LOGS_SUCCESS, (state, action) => {
    const { response = {} } = action;
    const { result = {} } = response;
    const { related = {} } = result;
    const { Notebook } = related;
    if (Notebook) {
      return { ...state, ...Notebook };
    }
    return state;
  });
});

export default reducer;
